import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { StringExt } from '@antv/x6';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowEdgeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsAddEdge;
(function (NsAddEdge) {
    /** Command: 用于注册named factory */
    NsAddEdge.command = XFlowEdgeCommands.ADD_EDGE;
    /** hookName */
    NsAddEdge.hookKey = 'addEdge';
    /** edge id 类型 */
    NsAddEdge.createEdgeId = (edge) => {
        if (StringExt.isString(edge.source)) {
            return `${edge.source}:${edge.sourcePortId}-${edge.target}:${edge.targetPortId}`;
        }
        if (isX6EdgeConfig(edge)) {
            const x6EdgeConfig = edge;
            return `${x6EdgeConfig.source.cell}:${x6EdgeConfig.source.port}-${x6EdgeConfig.target.cell}:${x6EdgeConfig.target.port}`;
        }
        if (isX6EdgePlainConfig(edge)) {
            const x6EdgeConfig = edge;
            return `${x6EdgeConfig.sourceCell}:${x6EdgeConfig.sourcePort}-${x6EdgeConfig.targetCell}:${x6EdgeConfig.targetPort}`;
        }
    };
    function isX6EdgeConfig(edge) {
        return edge.source && edge.source.cell && StringExt.isString(edge.source.cell);
    }
    NsAddEdge.isX6EdgeConfig = isX6EdgeConfig;
    function isX6EdgePlainConfig(edge) {
        return edge.sourceCell && StringExt.isString(edge.sourceCell);
    }
    NsAddEdge.isX6EdgePlainConfig = isX6EdgePlainConfig;
})(NsAddEdge || (NsAddEdge = {}));
let AddEdgeCommand = 
/** 创建节点命令 */
class AddEdgeCommand {
    constructor() {
        /** 处理edgeConfig的兜底逻辑 */
        this.processEdgeConfig = (args, edge) => __awaiter(this, void 0, void 0, function* () {
            /** 处理edgeConfig没有返回id的问题 */
            if (!edge.id) {
                const { createIdService = NsAddEdge.createEdgeId } = args;
                edge.id = yield createIdService(edge);
            }
            /** 处理xflow edge 和x6 edge的字段差异  */
            if (edge.sourcePortId && !edge.sourcePort) {
                edge.sourcePort = edge.sourcePortId;
                edge.targetPort = edge.targetPortId;
            }
            return edge;
        });
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.addEdge.call(
            /** 执行 hooks pipeline处理args */
            args, 
            /** 执行 callback */
            (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { cellFactory, createEdgeService, commandService, options } = handlerArgs;
                const graph = yield this.ctx.getX6Graph();
                let rawEdge = handlerArgs.edgeConfig;
                // 通过createEdgeService来获取 id/是否可以添加的信息，如果返回的nodeid为空则不添加到画布
                if (createEdgeService) {
                    const res = yield createEdgeService(handlerArgs);
                    if (typeof res === 'boolean') {
                        return { err: 'createEdgeService rejected' };
                    }
                    rawEdge = res;
                }
                const edgeConfig = yield this.processEdgeConfig(handlerArgs, rawEdge);
                let edgeCell;
                const eventOptions = Object.assign(Object.assign({}, options), { isCommand: true });
                if (cellFactory) {
                    const cell = yield cellFactory(edgeConfig, this);
                    edgeCell = graph.addEdge(cell, eventOptions);
                }
                else {
                    edgeCell = graph.addEdge(Object.assign(Object.assign({}, edgeConfig), { 
                        /** 由于X6的实现是React节点挂在label上的, 所以必须要给label设置值 */
                        label: (edgeConfig === null || edgeConfig === void 0 ? void 0 : edgeConfig.label) || edgeConfig, data: Object.assign({}, edgeConfig) }), eventOptions);
                }
                /** 创建 undo */
                const undo = Disposable.create(() => {
                    commandService.executeCommand(XFlowEdgeCommands.DEL_EDGE.id, {
                        x6Edge: edgeCell,
                    });
                });
                /** add undo */
                this.ctx.addUndo(undo);
                return { edgeConfig: edgeConfig, edgeCell };
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], AddEdgeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AddEdgeCommand.prototype, "init", null);
AddEdgeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsAddEdge.command.id },
    })
    /** 创建节点命令 */
], AddEdgeCommand);
export { AddEdgeCommand };
//# sourceMappingURL=edge-add.js.map